module.exports = __webpack_public_path__ + "img/froot_logo.065a9f66.svg";